// extracted by mini-css-extract-plugin
module.exports = {"ImageContainer":"QuizImage_ImageContainer__3wbk-"};